/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation SenderRouteUpdateMutation($routeId: ID!,$customerAccountId: ID!, $type: CUSTOMER_TYPE, $displayName: String) {
  SenderRouteUpdate(routeId: $routeId, customerAccountId: $customerAccountId, type: $type, displayName: $displayName) {
    message
    status
  }
}
`
